'use client';
import { saveVersionSwitch } from '@/services/versionSwitcher';
import { useSession } from 'next-auth/react';
import Link from 'next/link';
import { useState } from 'react';
import { createPortal } from 'react-dom';

const OLD_VERSION_URL = process.env.NEXT_PUBLIC_API_URL || 'https://bingowendake-prod.azurewebsites.net';

const OldVersionToggler = () => {
  const [showModal, setShowModal] = useState(false);
  const [feedback, setFeedback] = useState('');
  const maxChars = 2000;
  const { status } = useSession();

  const handleOldVersion = async () => {
    const usersBrowser = navigator.userAgent;
    const dateNow = new Date(Date.now()).toISOString();
    const versionSwitch = {
      UserName: '',
      Version: 'New to Old',
      Browser: usersBrowser,
      Comment: status === 'authenticated' ? feedback : '',
      Date: dateNow,
    };
    await saveVersionSwitch(versionSwitch, usersBrowser);
    window.location.href = OLD_VERSION_URL;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleOldVersion();
  };

  const modal = (
    <>
      <div className={'modal fade show'} style={{ display: 'block', zIndex: 10000 }} tabIndex="-1">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Aidez-nous à améliorer l&apos;application</h5>
              <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
            </div>
            <div className="modal-body">
              <p className="mb-3">
                Pour nous aider à améliorer l&apos;application, merci de nous indiquer pourquoi vous souhaitez revenir à l&apos;ancienne version.<br />
                Vous pouvez nous donner des détails sur le problème rencontré, ce qui vous aidera à mieux utiliser l&apos;application.
              </p>
              <ul className="mb-3 small text-muted" style={{ paddingLeft: '1.2em' }}>
                <li>Quelle action étiez-vous en train d&apos;effectuer lorsque le problème est survenu&nbsp;?</li>
                <li>Votre appareil est-il connecté à Internet via Wi-Fi, câble réseau (Ethernet) ou réseau mobile (4G/5G)&nbsp;?</li>
                <li>Un message d&apos;erreur ou un comportement inhabituel est-il apparu à l&apos;écran&nbsp;? Si oui, indiquez le message affiché.</li>
                <li>Est-ce la première fois que ce problème se produit, ou est-ce déjà arrivé auparavant&nbsp;?</li>
                <li>Avez-vous testé l&apos;application sur un autre appareil (ordinateur, téléphone, tablette) pour vérifier si le problème persiste&nbsp;?</li>
              </ul>
              <form onSubmit={handleSubmit}>
                {status === 'authenticated' ? (
                  <div className="mb-3">
                    <textarea 
                      className="form-control" 
                      value={feedback}
                      onChange={(e) => {
                        if (e.target.value.length <= maxChars) setFeedback(e.target.value);
                      }}
                      placeholder="Décrivez le problème rencontré..."
                      rows="4"
                      maxLength={maxChars}
                    ></textarea>
                    <div className="text-end small text-muted">
                      {feedback.length} / {maxChars} caractères
                    </div>
                  </div>
                ) : (
                  <div className="alert alert-info text-center mb-3">
                    Vous devez être connecté pour laisser un commentaire, mais vous pouvez continuer sans commentaire.
                  </div>
                )}
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Annuler</button>
                  <button type="submit" className="btn btn-primary">Continuer vers l&apos;ancienne version</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );

  return (
    <>
      <div className="form-check form-switch d-flex align-items-center ps-1">
        <Link
          href="#"
          className="form-check-label nav-link ps-1"
          onClick={(e) => {
            e.preventDefault();
            setShowModal(true);
          }}
        >
          Retour à l&apos; ancienne version
        </Link>
      </div>
      {showModal && typeof window !== 'undefined' && createPortal(modal, document.getElementById('root'))}
    </>
  );
};

export default OldVersionToggler;
